module.exports = __webpack_public_path__ + "img/d954993.png";